<h2>You have elected not to provide consent for your claim at this time. As a result, we are unable to process your claim or determine any benefits you may be eligible for under your coverage.
    <br/><br/>
    You can access the claims portal to begin the filing process if you elect to provide consent at a later time.
</h2>
